import { mergeByProp } from '@shared/utils/mergeByProp.js';
import { createReducer } from '../lib/createReducer.js';

const initialState = {
  docsLoading: {},
  appDoc: [],
  appDocNeedsFetch: []
};

export default createReducer(initialState, {
  SET_DOCS_LOADING: (state, payload) => ({
    ...state,
    docsLoading: payload
  }),

  GET_PUB_SUB_MESSAGE_docsLoading: (state, payload) => ({
    ...state,
    docsLoading: { ...state.docsLoading, [payload.data.appId]: payload.data.value }
  }),

  GET_APP_DOC_META_SUCCESS: (state, payload) => ({
    ...state,
    appDoc: mergeByProp('id', state.appDoc, Array.isArray(payload.data) ? payload.data : [payload.data])
  }),

  GET_PUB_SUB_MESSAGE_SHOULD_FETCH_APP_DOC_META: (state, payload) => ({
    ...state,
    appDocNeedsFetch: [...state.appDocNeedsFetch, { ...payload.data }]
  }),

  CLEAR_APP_DOC_NEEDS_FETCH: (state) => ({
    ...state,
    appDocNeedsFetch: []
  })
});
